import axios from "axios";
import { getTokenOnStorage } from "../services/user";

const API_URL = process.env.REACT_APP_API_THOR_URL;

const api = axios.create({
  baseURL: API_URL,
  responseType: "json",
});

api.interceptors.request.use((config) => {
  const token = getTokenOnStorage();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
